<template>
    <div>
        <div @click="back" class="header">
            <i class="iconfont">&#xe604;</i>
        </div>
        <div>
            <div class="base_info">
                <h5>基本信息</h5>
                <div class="info">
                    <p>订单序号：<span>{{list.order_id}}</span></p>
                    <p>订单编号：<span>{{list.ordernum}}</span></p>
                    <p>订单状态：<span>{{list.orderstate}}</span></p>
                    <p>下单时间：<span>{{list.ordertime}}</span></p>
                </div>
            </div>
            <div class="user_info">
                <h5>用户信息</h5>
                <div class="info">
                    <p>买家名称：<span>{{list.username}}</span></p>
                    <p>用户等级：<span class="level">{{list.userlevel}}</span></p>
                </div>
            </div>
            <div class="pay_info">
                <h5>支付信息</h5>
                <div class="info">
                    <p>支付方式：<span>{{list.payway}}</span></p>
                    <p>支付时间：<span>{{list.paytime}}</span></p>
                </div>
            </div>
            <div class="order_info">
                <h5>订单信息</h5>
                <div class="order-message" v-for="gitem in list.goodslist" :key="gitem.good_id">
                    <div class="order_img">
                        <img :src="gitem.goodsimg ? url + gitem.goodsimg : defaultimg">
                    </div>
                    <div class="goods_info">
                        <div>
                            <p class="goodsid">货号：<span>{{gitem.good_id}}</span></p>
                            <p class="title">{{gitem.goodtitle}}</p>
                        </div>
                        <div class="order-price">
                            <p>￥{{gitem.goodprice}}</p>
                            <p class="num">x{{gitem.goodnum}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="remark">
                <h5>买家备注：</h5>
                <div class="info">
                    <p>{{list.remark}}</p>
                </div>
            </div>
            <div class="totprice">
                <p>订单合计：<span>￥{{list.totprice}}</span></p>
            </div>
        </div>
    </div>
</template>

<script>
import url from '@/common/common.js'
export default {
  name: 'SelledDetail',
  props: {
    list: Object
  },
  data () {
    return {
      url,
      defaultimg: '/static/img/defaultimg.jpg' // 默认图片
    }
  },
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    }
  }
}
</script>

<style scoped>
h5{ font-weight: normal; font-size: 14px; color: #666; padding: 11px 8px; background: #efefef;}
.header{ padding: 7px 13px; background: #fff;}
.header .iconfont{ font-size: 25px;}
.header a{ text-decoration: none;}
.order-message{ display: flex; justify-content: flex-start; font-size: 14px;}
.order-message{ padding: 10px 15px; margin-bottom: 5px;}
.order-message img{ margin-right: 11px; width: 80px; height: 80px;}
.order_img{ width: 26%;}
.goods_info{ width: 74%;}
.num{ color: #434343; float: right;}
.order-price{ overflow: hidden; padding-top: 5px;}
.order-price p:first-child{ float: left; color: #ff0135;}
.info{ margin: 0 8px;}
.info p{ padding: 10px 0; color: #999; border-bottom: 1px solid #f2f2f2;}
.info span{ color: #666;}
.info span.level{ background: #ff0135; color: #fff; padding: 3px 6px; border-radius: 5px; font-size: 12px;}
.totprice{ background: #f2f2f2; padding: 10px 8px;}
.totprice span{ float: right; color: #ff0135;}
</style>



// WEBPACK FOOTER //
// src/pages/selled_detail/components/Content.vue